import Icon from '@katalon-studio/katalon-ui/Icon';
import React from 'react';
import colors from '../../../scss/colors.scss';

function ArrowTurnDownRightIcon({ color, textSize }) {
  return <Icon
    type="fa-regular"
    name="fa-arrow-turn-down-right"
    textSize={textSize}
    sx={{
      color,
    }}
    boundingSize={null}
    color={null}
  />;
}

ArrowTurnDownRightIcon.defaultProps = {
  color: colors.gray9,
  textSize: '14px',
};

export default ArrowTurnDownRightIcon;
